//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { RadioSection } from "@Shared/components/sections";
import MaterialInput from "@Shared/components/inputs/material-input";
import { validationMixin } from "vuelidate";
import { requiredIf, minLength } from "vuelidate/lib/validators";
import DatepickerInput from "@Shared/components/inputs/datepicker-input.vue";
import { validDate } from "@Shared/@Utils/validation-rules";
import { isEmpty } from "lodash";
import FilterByApplicationStatus from "../../filter-by-application-status.vue";
import { defineComponent } from "@vue/composition-api";
export default defineComponent({
  name: "FireImportStep",
  components: {
    MaterialInput,
    RadioSection,
    DatepickerInput,
    FilterByApplicationStatus
  },
  mixins: [validationMixin],
  validations() {
    return {
      localExpertDealId: {
        required: requiredIf(function () {
          return this.isSingleDeal;
        }),
        minLength: minLength(this.isSingleDeal ? 6 : 0)
      },
      localStartDate: {
        required: requiredIf(function () {
          return this.isDateRange;
        }),
        validDate
      },
      localEndDate: {
        required: requiredIf(function () {
          return this.isDateRange;
        }),
        validDate
      }
    };
  },
  props: {
    expertDealId: {
      type: String,
      default: null
    },
    selectedImportType: {
      type: String,
      default: null
    },
    startDate: {
      type: String,
      default: null
    },
    endDate: {
      type: String,
      default: null
    },
    filterByStatus: {
      type: Boolean,
      default: false
    },
    statusList: {
      type: Array,
      default: null
    },
    filogixDetails: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      typeOptions: [{
        label: this.$t("application.actions.import.allApplications.label"),
        description: this.$t("application.actions.import.allApplications.description"),
        value: "all-applications"
      }, {
        label: this.$t("application.actions.import.dateRange.label"),
        description: this.$t("application.actions.import.dateRange.description"),
        value: "date-range"
      }, {
        label: this.$t("application.actions.import.singleDeal.label"),
        description: this.$t("application.actions.import.singleDeal.description"),
        value: "single-deal"
      }]
    };
  },
  computed: {
    isSingleDeal() {
      return this.selectedType === "single-deal";
    },
    isDateRange() {
      return this.selectedType === "date-range";
    },
    showNote() {
      return !(isEmpty(this.selectedType) || this.isSingleDeal);
    },
    localExpertDealId: {
      get() {
        return this.expertDealId;
      },
      set(value) {
        this.$emit("update:expertDealId", value);
      }
    },
    selectedType: {
      get() {
        return this.selectedImportType;
      },
      set(value) {
        this.$emit("update:selectedImportType", value);
      }
    },
    localStartDate: {
      get() {
        return this.startDate;
      },
      set(value) {
        this.$emit("update:startDate", value);
      }
    },
    localEndDate: {
      get() {
        return this.endDate;
      },
      set(value) {
        this.$emit("update:endDate", value);
      }
    },
    localFilterByStatus: {
      get() {
        return this.filterByStatus;
      },
      set(value) {
        this.$emit("update:filterByStatus", value);
      }
    },
    localStatusList: {
      get() {
        return this.statusList;
      },
      set(value) {
        this.$emit("update:statusList", value);
      }
    }
  },
  watch: {
    selectedType() {
      this.localExpertDealId = this.isSingleDeal ? this.filogixDetails.firmCode : null;
      this.localStartDate = null;
      this.localEndDate = null;
      this.localFilterByStatus = false;
      this.localStatusList = [];
      this.$v.$reset();
    }
  },
  methods: {
    handleChangeRange(range) {
      this.localStartDate = range.start;
      this.localEndDate = range.end;
    },
    handleRadioBtnChange(value) {
      if (value === "application-status") {
        this.localFilterByStatus = true;
      } else {
        this.localFilterByStatus = false;
        this.localStatusList = [];
      }
    },
    handleStatusChange(data) {
      this.localStatusList = data;
    }
  }
});